import React from 'react'
// import { Button, Form, Input, Select, Radio } from 'antd'

// mobx
import { useStore } from '@/store'
// import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx
import {Video} from '@/components'

import {CaretUpOutlined,FullscreenOutlined,FullscreenExitOutlined  } from "@ant-design/icons";

const DhspInput = () => {
  const { DhspStore } = useStore()
  //获得table数据
  const getAddButton =(data) => {
      DhspStore.onClickBtn(data,0)
    setTimeout(() => {
      DhspStore.onClickBtn(data,1)
    }, 500);
  };

  return (
    <>
         <Video url={DhspStore.url} forceHLS={true} height></Video>
         {
          DhspStore.url&&(
            <div className='ytkz'>
            <ul className='abbr'>
              <li onClick={() => getAddButton('ZOOM_IN')}><FullscreenOutlined /></li>
              <li onClick={() => getAddButton('ZOOM_OUT')}><FullscreenExitOutlined /></li>
            </ul>
            <ul className='amp'>
              <li onClick={() => getAddButton('LEFT_UP')}><CaretUpOutlined rotate={320} style={{marginLeft:'-30px'}}/></li>
              <li onClick={() => getAddButton('UP')}><CaretUpOutlined/></li>
              <li onClick={() => getAddButton('RIGHT_UP')}><CaretUpOutlined rotate={40} style={{marginRight:'-30px'}}/></li>
              <li  onClick={() => getAddButton('LEFT')} style={{margin:'15px 0'}}><CaretUpOutlined rotate={270} style={{marginLeft:'-30px'}}/></li>
              <li style={{height:'50px',background:'#959595',marginTop:'5px'}}></li>
              <li onClick={() => getAddButton('RIGHT')} style={{margin:'15px 0'}}><CaretUpOutlined rotate={-270} style={{marginRight:'-30px'}}/></li>
              <li onClick={() => getAddButton('LEFT_DOWN')}><CaretUpOutlined rotate={230} style={{marginLeft:'-30px'}}/></li>
              <li onClick={() => getAddButton('DOWN')}><CaretUpOutlined rotate={180} /></li>
              <li onClick={() => getAddButton('RIGHT_DOWN')}><CaretUpOutlined rotate={130} style={{marginRight:'-30px'}}/></li>
            </ul>
           </div>
          )
         }

    </>
  )
}

export default observer(DhspInput)